import { ApplicationSource, ApplicationStatus } from '../constants';
import { ApplicationDetails } from '../interfaces/entities';

export function isApplicationLockedForStatusChange(
  application: Pick<
    ApplicationDetails,
    'source' | 'status' | 'employerMetadata'
  >
) {
  return (
    application.source === ApplicationSource.RECOMMENDED_TALENT &&
    application.status === ApplicationStatus.NEW &&
    !application.employerMetadata?.firstCandidateRepliedAt
  );
}
